(async function(algolia) {
  'use strict';

  if (!algolia.config.autocomplete_enabled) return;

  const {autocomplete} = algolia.externals;

  const index_suffix = await algolia.config.index_suffix;

  algolia.searchClient.addAlgoliaAgent('Shopify Integration');

  if (algolia.config.dynamic_selector) {
    const search_url = algolia?.shopify?.routes?.search_url || `${window.Shopify.routes.root}/search`;
    const default_form_search = `form[action="${search_url}"]`;
    algolia.config.input_selector += `, ${default_form_search}`;
  }
  
  // Retrieve the container from Shopify's config
  const containers = Array.from(document.querySelectorAll(algolia.config.input_selector));
  containers.forEach((container) => {
    container.innerHTML = ''
    const containerClasses = container.classList;
    containerClasses.add('aa-MainContainer');
  });

  // Set plugins
  const { productsPlugin, collectionsPlugin, querySuggestionsPlugin } = algolia;
  const plugins = [
    algolia.config.index_products && productsPlugin,
    algolia.config.index_collections && collectionsPlugin,
    algolia.config.autocomplete_query_suggestions && querySuggestionsPlugin,
  ];

  const cssFile = document.getElementById('template_algolia_autocomplete.css');
  //Set CSS variables
  document.documentElement.style.setProperty('--aa-text-color-rgb', `${algolia.helpers.hexToRGB(algolia.config.colors.secondary)}`);
  document.documentElement.style.setProperty('--aa-primary-color-rgb', `${algolia.helpers.hexToRGB(algolia.config.colors.main)}`);
  document.documentElement.style.setProperty('--aa-muted-color-rgb', `${algolia.helpers.hexToRGB(algolia.config.colors.muted)}`);
  document.documentElement.style.setProperty('--aa-highlight-color-rgb', `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`);
  //Link CSS
  algolia.appendStyle(cssFile.text);

  let previousFlagValue;
  const observer = new MutationObserver((mutations) => {
      mutations.forEach(({ addedNodes }) => {
        if (!addedNodes?.length) return;

        const { [0]: panelEl } = addedNodes;
        if (![...panelEl.classList].includes('aa-Panel')) return;

        const flagValue = window._growthbook.getFeatureValue('web_quick_win_iterate_on_search');

        if ((previousFlagValue === 0 && [1, 2].includes(flagValue)) || (flagValue === 0 && [1, 2].includes(previousFlagValue))) {
          [...document.querySelectorAll('li.previous-search-selection')].forEach((el) => el.remove());
        }
        
        switch(flagValue) {
          default:
          case 0:
            panelEl.classList.remove('gb-new', 'gb-variation1', 'gb-variation2');
            panelEl.classList.add('gb-orig');
            break;
          case 1:
            panelEl.classList.remove('gb-orig', 'gb-variation2');
            panelEl.classList.add('gb-new', 'gb-variation1');
            break;
          case 2:
            panelEl.classList.remove('gb-orig', 'gb-variation1');
            panelEl.classList.add('gb-new', 'gb-variation2');
            break;
        }

        previousFlagValue = flagValue;
      });
  });
  observer.observe(document.body, { childList: true });

  // let hasAddedTrackingEventHandler;

  const autocompleteOptions = {
    openOnFocus: true,
    debug: algolia.config.autocomplete_debug,
    insights: algolia.config.analytics_enabled,
    placeholder: 'Find Your Pair',
    detachedMediaQuery: 'none',
    panelPlacement: 'full-width',
    plugins,
    render: ({ elements, render, html, state }, root) => {
      const newSearchImplementation = window._growthbook?.getFeatureValue('web_quick_win_iterate_on_search') !== 0;
      const sourceIdsToExclude = newSearchImplementation ?['products','collections']:['products']
      const hasLeftPanelResults = state.collections
        .filter(({ source }) => sourceIdsToExclude.indexOf(source.sourceId) === -1)
        .reduce((prev, curr) => prev + curr.items.length, 0) > 0;
      const [querySuggestionsPluginResults] = state.collections.filter(({source}) => source.sourceId === 'querySuggestionsPlugin');
      const displaySuggestions = algolia.config.autocomplete_query_suggestions && querySuggestionsPluginResults.items.length > 0;

      if (newSearchImplementation && !hasLeftPanelResults && !elements.products) {
        const leftPanelSectionEl = document.querySelector('.aa-PanelSection--left');
        if (leftPanelSectionEl) leftPanelSectionEl.style.display = 'none';
      }

      render(
        hasLeftPanelResults
          ? algolia.mainTemplate({ html, state }, elements, displaySuggestions)
          : elements.products || !newSearchImplementation
            ? algolia.mainProductsTemplate({ html, state }, elements)
            : algolia.noResultsTemplate({ html, state }),
        root
      );

      // send mixpanel events
      // const mixpanelTrackingArea = document.querySelector('.aa-PanelSections');
      // if (!mixpanelTrackingArea || hasAddedTrackingEventHandler) return;

      // mixpanelTrackingArea.addEventListener('click', (e) => {
      //   const parentAEl = e.target.closest('a');
      //   if (parentAEl && parentAEl.dataset.type) {
      //     const currentSearchTerm = document.querySelector('.aa-Input').value;
      //     const sendObj = {
      //       keywords: currentSearchTerm,
      //       clickSuggestType: parentAEl.dataset.type,
      //       title: parentAEl.dataset.title,
      //     };
      //       mixpanel.track('Search Suggest', sendObj);
      //   };
      // });
      // hasAddedTrackingEventHandler = true;

      //send ga events
      const sendGaSearchMethod = (eTarget, searchMethod) => {
        const searchTerm = eTarget.dataset.title;
       
        gtag('event','user_search', {
          search_method: searchMethod,
          search_term: searchTerm,
        })

        }
      
        const searchPanel = document.querySelector('.aa-Panel')
        searchPanel.addEventListener('click', (e) => {
        e.preventDefault();
        const eTarget = e.target.closest('a');
        if(!eTarget) return;

        const querySuggestedItems = e.target.closest('.aa-PanelSection--left .aa-Source .aa-List .aa-Item');
        const queryProductSuggestedItems = e.target.closest('.aa-PanelSection--right .aa-Source .aa-List .aa-Item');
        const queryOnlyProductItems = e.target.closest('.aa-PanelSection.aa-PanelOnlyProduct .aa-Source .aa-List .aa-Item');

        if (queryOnlyProductItems) {
          sendGaSearchMethod(eTarget,'product_search')
        } else if (queryProductSuggestedItems){
          sendGaSearchMethod(eTarget,'product_search')
        } else if (querySuggestedItems){
          sendGaSearchMethod(eTarget,'suggested_search')
        }
        window.location.href = eTarget.getAttribute('href');
        });

    },
    renderNoResults: ({ render, html, state }, root) => {
      if(state.query !== ''){
        if (window._growthbook.getFeatureValue('web_quick_win_iterate_on_search') !== 0) {
          const leftPanelSectionEl = document.querySelector('.aa-PanelSection--left');
          if (leftPanelSectionEl) leftPanelSectionEl.style.display = 'none';
        }

        render(
          algolia.noResultsTemplate({ html, state }),
          root
        );
      }
    },
    onSubmit: ({ state }) => {
      // mixpanel.track('Product Search', {
      //   keywords: state.query,
      // });

      window.location.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(state.query)}`;
    },
  };
  
  containers.forEach((container) => {
    autocomplete({
      container,
      ...autocompleteOptions,
    });
  });
})(window.algoliaShopify);
